<div class="table">
  <div class="table-height">
    <div class="table-box">
      <table>
        <thead>
          <tr>
            @for (propriete of proprietesAffichees; track propriete; let i = $index) {
              <th width="{{table_width[i] + '%' }}" >
                <div class="table-header-item">
                  <span>{{ propriete.libelleAffiche | translate }}</span>
                </div>
              </th>
            }
            <th class="toggle-col">{{ 'GLOBAL.ACTIF' | translate }}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (l of tabLithologies(); track l; let i = $index) {
            <tr [class.modifiable]="isModifiable === i" [class.inactive]="!l.isActive" (click)="selectLithology(l,i, $event)" >
              <td  [title]="l.id" style="padding-left: 10px;">{{ l.id }}</td>
              <td  [title]="l.name">
                <input type="text"  [(ngModel)]="l.name" [disabled]="isModifiable !== i"  [class.modifiable]="isModifiable === i" name="name1"  #name1="ngModel" [ngClass]="{'error-value': name1.errors?.required  && showErrorModif}" required  />
              </td>
              <td  [title]="l.code">
                <input type="number"  [(ngModel)]="l.code" [disabled]="isModifiable !== i"    [class.modifiable]="isModifiable === i" name="code1"  #code1="ngModel"  [ngClass]="{'error-value': code1.errors?.required  && showErrorModif}" required  />
              </td>
              <td  [title]="l.rockType">
                <input type="text"  [(ngModel)]="l.rockType" [disabled]="isModifiable !== i"    [class.modifiable]="isModifiable === i" name="rockType1"  #rockType1="ngModel"  [ngClass]="{'error-value': rockType1.errors?.required  && showErrorModif}" required  />
              </td>
              <td  [title]="l.description">
                <input type="text"  [(ngModel)]="l.description" [disabled]="isModifiable !== i" style="text-align: left;" [class.modifiable]="isModifiable === i" name="description1"  #description1="ngModel"  [ngClass]="{'error-value': description1.errors?.required  && showErrorModif}" required  />
              </td>
              <td  [title]="l.color">
                <input type="text" style="margin-left: 1px; border-color:#D3D3D3" [cpPosition]="'left'"   [cpAlphaChannel]="'disabled'"  [class.modifiablePicker]="isModifiable === i"    [style.background]="l.color" [value]="l.color" [(colorPicker)]="l.color" name="colorSelected"  [disabled]="isModifiable !== i" [style.cursor]="isModifiable === i ? 'pointer' : 'auto'"  required />
              </td>
              <td class="toggle-col" (click)="$event.stopPropagation()">
                <label class="toggle-switch">
                  <input type="checkbox" [checked]="l.isActive" (change)="toggleIsActive(l)">
                  <span class="slider"></span>
                </label>
              </td>
              <td><div class="icon">@if (isModifiable === i) {
                <button  class="btn btn-primary"><i [title]="'GLOBAL.MODIFIER' | translate"  class="fas fa-save" (click)="update(l,i)"></i></button>
              }</div></td>
              <td><div class="icon">@if (isModifiable === i) {
                <button class="btn btn-primary"><i  [title]="'GLOBAL.SUPPRIMER' | translate" class="fas fa-trash-alt" (click)="delete(l)"></i></button>
              }</div></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="footer" [class.focus]="isFooterFocus"  (focusout)="onFocusOutEvent()"  >
    <div class="edit-box">
      <div class="input-id"> <span ><b>{{ 'GLOBAL.AJOUTER'| translate }}</b></span> </div>
      <div class="input"><input type="text"  [(ngModel)]="newLithology.name"        (focus)="newLithologyChange()"   name="name2"          #name2="ngModel"         [ngClass]="{'error-value': name2.errors?.required  && showErrorNew}"        required /></div>
      <div class="input"><input type="number" [(ngModel)]="newLithology.code"        (focus)="newLithologyChange()"   name="code2"          #code2="ngModel"         [ngClass]="{'error-value': code2.errors?.required  && showErrorNew}"        required /></div>
      <div class="input"><input type="text"  [(ngModel)]="newLithology.rockType"    (focus)="newLithologyChange()"   name="rockType2"      #rockType2="ngModel"     [ngClass]="{'error-value': rockType2.errors?.required  && showErrorNew}"    required /></div>
      <div class="input"><input type="text"  [(ngModel)]="newLithology.description" (focus)="newLithologyChange()"   name="description2"   #description2="ngModel"  [ngClass]="{'error-value': description2.errors?.required  && showErrorNew}" required /></div>
      <div class="input">
        <input type="text" readonly  [value]="newLithology.color" [cpPosition]="'top-left'" (focus)="newLithologyChange()"   [cpAlphaChannel]="'disabled'"  [(colorPicker)]="newLithology.color" style="margin-left:0px;"  name="colorSelected"  [style.background]="newLithology.color"   required />
      </div>
      <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-save" (click)="createLithology()"></i></button></div>
      <div class="icon" style="width: 7%;"><button  class="btn btn-primary"><i class="fas fa-eraser" (click)="clearNew()"></i></button></div>
    </div>
  </div>
</div>